import React, { useState } from 'react';
import { Calendar, Video } from 'lucide-react';
import { Modal } from './Modal';

export const ContactSection = () => {
  const [showCalendar, setShowCalendar] = useState(false);

  return (
    <>
      <section className="max-w-2xl mx-auto bg-white/10 backdrop-blur-sm rounded-lg p-8 shadow-xl">
        <h2 className="text-3xl font-bold mb-6 text-center">Schedule a Consultation</h2>
        <div className="text-center">
          <div className="flex justify-center items-center mb-6">
            <Calendar className="w-12 h-12 text-yellow-400 mr-4" />
            <Video className="w-12 h-12 text-blue-400" />
          </div>
          <p className="text-lg text-gray-200 mb-8">
            Ready to transform your business with AI-powered solutions? Let's discuss your goals and create a customized strategy for your success.
          </p>
          <button
            onClick={() => setShowCalendar(true)}
            className="inline-flex items-center bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <Video className="w-6 h-6 mr-3" />
            Schedule Google Meet Consultation
          </button>
          <p className="text-sm text-gray-300 mt-4">
            Click to schedule your free consultation
          </p>
        </div>
      </section>

      <Modal
        isOpen={showCalendar}
        onClose={() => setShowCalendar(false)}
        title="Schedule Your Consultation"
      >
        <div className="w-full h-[600px]">
          <iframe
            src="https://calendar.app.google/epNbrco2PxDLDaRF6"
            className="w-full h-full border-0 rounded"
            title="Google Calendar Scheduler"
          />
        </div>
      </Modal>
    </>
  );
};